import { render, staticRenderFns } from "./ot-address-field-wrapper.vue?vue&type=template&id=79d354a6&scoped=true&"
import script from "./ot-address-field-wrapper.vue?vue&type=script&lang=ts&"
export * from "./ot-address-field-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ot-address-field-wrapper.vue?vue&type=style&index=0&id=79d354a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d354a6",
  null
  
)

export default component.exports